module.exports = __webpack_public_path__ + "static/media/schedLimitPowerOff.99d87fd4.svg";